<div class="card">

    <div class="card-header">
        <h5>{{"MESSAGE.Molim pričekajte" | translate}}</h5>
    </div>
    <div class="card-body">
        <div class="text-center">
            <fa-icon [icon]="faSpinner" size="6x" animation="spin" class="mt-2 mb-2 txt-primary"></fa-icon>
        </div>
    </div>
</div>